// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.routes_heading__gPzej {
    font-size: 28px;
    font-weight: 600;
}

.routes_base__Fx5Rw {
    background: #fff;
    padding: 40px;
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 10px 20px;
    max-width: 1800px;
}

#routes_boxCont__e6yPy {
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #eee;
}
.routes_flexContainer__hj4lH {
    display: flex;
    gap: 20px;
    flex-direction: row;
    padding: 10px;
}

.routes_flexContainer__hj4lH #routes_flex__dvTxz {
    flex: 1 1;
    border-radius: 10px;
}

.routes_bar__D05fk {
    box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
    border-radius: 50%;
}

.routes_wallet__\\+g-WD,
.routes_notEditable__57BK0 {
    padding: 15px;
    border: 1px solid #eee;
    border-bottom: 3px solid #0076ff;
    border-radius: 10px;
}
.routes_flexContainer__hj4lH #routes_flex__dvTxz input {
    width: 100%;
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 10px;
    border-bottom: 2px solid #0076ff;
    outline: none;
    transition: all ease 300ms;
}
.routes_wallet__\\+g-WD p,
.routes_notEditable__57BK0 p {
    font-size: 20px;
    color: #333;
}

.routes_formButtonE__mx6Af {
    padding: 10px 20px;
    background:#0076ff;
    border: 1px solid #0076ff;
    color: #fff;
    outline: none;
    width: 100%;
    font-weight: 600;
    cursor: pointer;
    border-radius: 10px;
    transition: all ease 300ms;
}
.routes_formButtonE__mx6Af:hover {
    background: #111;
    border: 1px solid #111;
    box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
}
.routes_centerDrag__Gjmpe {
    margin: auto;
    width: 140px;
    margin-top: 40px;
    margin-bottom: 38px;
}

.routes_topChildH4__BnbD9 {
    margin-top: 1em;
}

.routes_notEditable__57BK0 h4 {
    margin-left: 1em;
}

/* css for lower container */
.routes_flexContainerK__hspbz {
    gap: 20px;
    display: flex;
    flex-direction: row;
    margin-bottom: 30px;
}

.routes_flexContainerK__hspbz #routes_flex__dvTxz label {
    font-size: 12.5px;
    font-weight: 600;
}

.routes_flexContainerK__hspbz #routes_flex__dvTxz input {
    width: 100%;
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 10px;
    border-bottom: 2px solid #0076ff;
    outline: none;
    transition: all ease 300ms;
}

#routes_flex_btn_container__Tv-7e {
    padding-top: 1.3em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
    transition: all ease 300ms;
}



#routes_flex_btn_container__Tv-7e input {
    width: 35%;
    margin-top: 4px;
    padding: 10px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 10px;
    border-bottom: 2px solid #0076ff;
    outline: none;
    height: 90%;
}

.routes_otpBtn__mjcPS {
    width: 25%;
    margin-top: 4px;
    padding: 5px;
    font-size: 12px;
    border: 1px solid #ccc;
    border-radius: 10px;
    border-bottom: 2px solid #0076ff;
    outline: none;
    background-color: #0076ff;
    color: #fff;
    height: 90%;
    transition: ease-in 300ms;
}

.routes_otpBtn__mjcPS:hover {
    cursor: pointer;
    background: #111;
    border: 1px solid #111;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
}

.routes_otpBtn__mjcPS::after {
    cursor: not-allowed;
}

.routes_preHeader__mPDj- {
    font-weight: 700;
    margin-top: 5px;
    font-size: 12.5px;
    color: #444;
    text-transform: uppercase;
}

.routes_notEditable__57BK0 hr {
    height: 1px;
    border: 0 none;
    background: #ddd;
    margin-top: 5px;
}

.routes_notEditable__57BK0 p {
    font-size: 16px;
    font-weight: 500;
    margin-top: 10px;
}

.routes_iconPara__0BkZC {
    padding-right: 5px;
}

.routes_lowerContainer__HtG7Z {
    padding: 10px;
}

#routes_selfieBox__BWbxs {
    width: 100%;
    border-radius: 10px;
    border: 1px solid #eee;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    border-bottom: 3px solid #0076ff;
}

#routes_selfieBox__BWbxs img {
    width: 100px;
    border: 1px solid #eee;
    border-radius: 10px;
    height: 100px;
    object-fit: cover;
}

#routes_selfieBox__BWbxs h3 {
    font-size: 18px;
    color: #333;
    font-weight: 600;
}

#routes_selfieBox__BWbxs p {
    font-size: 13.5px;
}


.routes_modalOpened__dahRz {
    display: flex;
    flex-direction: column;
}




@media (max-width: 992px) {
    .routes_flexContainer__hj4lH {
        display: flex;
        flex-direction: column;
        gap: 20px;
        align-items: left;
    }

    .routes_btnDiv__6bEwX{
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
    
    #routes_selfieBox__BWbxs {
        width: 100%;
        border-radius: 10px;
        border: 1px solid #eee;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        gap: 2em;
        border-bottom: 3px solid #0076ff;
    }


}`, "",{"version":3,"sources":["webpack://./src/core/css/routes.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,0BAA0B;AAC9B;AACA;;IAEI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,2FAA2F;AAC/F;AACA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,0BAA0B;AAC9B;;;;AAIA;IACI,UAAU;IACV,eAAe;IACf,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,WAAW;AACf;;AAEA;IACI,UAAU;IACV,eAAe;IACf,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,+FAA+F;AACnG;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,sBAAsB;AAC1B;;;;;AAKA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,sBAAsB;QACtB,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,8BAA8B;QAC9B,QAAQ;QACR,gCAAgC;IACpC;;;AAGJ","sourcesContent":[".heading {\n    font-size: 28px;\n    font-weight: 600;\n}\n\n.base {\n    background: #fff;\n    padding: 40px;\n    border: 1px solid #eee;\n    border-radius: 10px;\n    padding: 10px 20px;\n    max-width: 1800px;\n}\n\n#boxCont {\n    padding: 10px;\n    border-radius: 10px;\n    border: 1px solid #eee;\n}\n.flexContainer {\n    display: flex;\n    gap: 20px;\n    flex-direction: row;\n    padding: 10px;\n}\n\n.flexContainer #flex {\n    flex: 1;\n    border-radius: 10px;\n}\n\n.bar {\n    box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;\n    border-radius: 50%;\n}\n\n.wallet,\n.notEditable {\n    padding: 15px;\n    border: 1px solid #eee;\n    border-bottom: 3px solid #0076ff;\n    border-radius: 10px;\n}\n.flexContainer #flex input {\n    width: 100%;\n    padding: 10px;\n    font-size: 12px;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    border-bottom: 2px solid #0076ff;\n    outline: none;\n    transition: all ease 300ms;\n}\n.wallet p,\n.notEditable p {\n    font-size: 20px;\n    color: #333;\n}\n\n.formButtonE {\n    padding: 10px 20px;\n    background:#0076ff;\n    border: 1px solid #0076ff;\n    color: #fff;\n    outline: none;\n    width: 100%;\n    font-weight: 600;\n    cursor: pointer;\n    border-radius: 10px;\n    transition: all ease 300ms;\n}\n.formButtonE:hover {\n    background: #111;\n    border: 1px solid #111;\n    box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;\n}\n.centerDrag {\n    margin: auto;\n    width: 140px;\n    margin-top: 40px;\n    margin-bottom: 38px;\n}\n\n.topChildH4 {\n    margin-top: 1em;\n}\n\n.notEditable h4 {\n    margin-left: 1em;\n}\n\n/* css for lower container */\n.flexContainerK {\n    gap: 20px;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 30px;\n}\n\n.flexContainerK #flex label {\n    font-size: 12.5px;\n    font-weight: 600;\n}\n\n.flexContainerK #flex input {\n    width: 100%;\n    padding: 10px;\n    font-size: 12px;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    border-bottom: 2px solid #0076ff;\n    outline: none;\n    transition: all ease 300ms;\n}\n\n#flex_btn_container {\n    padding-top: 1.3em;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    cursor: pointer;\n    transition: all ease 300ms;\n}\n\n\n\n#flex_btn_container input {\n    width: 35%;\n    margin-top: 4px;\n    padding: 10px;\n    font-size: 12px;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    border-bottom: 2px solid #0076ff;\n    outline: none;\n    height: 90%;\n}\n\n.otpBtn {\n    width: 25%;\n    margin-top: 4px;\n    padding: 5px;\n    font-size: 12px;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    border-bottom: 2px solid #0076ff;\n    outline: none;\n    background-color: #0076ff;\n    color: #fff;\n    height: 90%;\n    transition: ease-in 300ms;\n}\n\n.otpBtn:hover {\n    cursor: pointer;\n    background: #111;\n    border: 1px solid #111;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;\n}\n\n.otpBtn::after {\n    cursor: not-allowed;\n}\n\n.preHeader {\n    font-weight: 700;\n    margin-top: 5px;\n    font-size: 12.5px;\n    color: #444;\n    text-transform: uppercase;\n}\n\n.notEditable hr {\n    height: 1px;\n    border: 0 none;\n    background: #ddd;\n    margin-top: 5px;\n}\n\n.notEditable p {\n    font-size: 16px;\n    font-weight: 500;\n    margin-top: 10px;\n}\n\n.iconPara {\n    padding-right: 5px;\n}\n\n.lowerContainer {\n    padding: 10px;\n}\n\n#selfieBox {\n    width: 100%;\n    border-radius: 10px;\n    border: 1px solid #eee;\n    padding: 20px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 30px;\n    border-bottom: 3px solid #0076ff;\n}\n\n#selfieBox img {\n    width: 100px;\n    border: 1px solid #eee;\n    border-radius: 10px;\n    height: 100px;\n    object-fit: cover;\n}\n\n#selfieBox h3 {\n    font-size: 18px;\n    color: #333;\n    font-weight: 600;\n}\n\n#selfieBox p {\n    font-size: 13.5px;\n}\n\n\n.modalOpened {\n    display: flex;\n    flex-direction: column;\n}\n\n\n\n\n@media (max-width: 992px) {\n    .flexContainer {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        align-items: left;\n    }\n\n    .btnDiv{\n        display: flex;\n        flex-direction: row;\n        gap: 10px;\n    }\n    \n    #selfieBox {\n        width: 100%;\n        border-radius: 10px;\n        border: 1px solid #eee;\n        padding: 20px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: space-between;\n        gap: 2em;\n        border-bottom: 3px solid #0076ff;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `routes_heading__gPzej`,
	"base": `routes_base__Fx5Rw`,
	"boxCont": `routes_boxCont__e6yPy`,
	"flexContainer": `routes_flexContainer__hj4lH`,
	"flex": `routes_flex__dvTxz`,
	"bar": `routes_bar__D05fk`,
	"wallet": `routes_wallet__+g-WD`,
	"notEditable": `routes_notEditable__57BK0`,
	"formButtonE": `routes_formButtonE__mx6Af`,
	"centerDrag": `routes_centerDrag__Gjmpe`,
	"topChildH4": `routes_topChildH4__BnbD9`,
	"flexContainerK": `routes_flexContainerK__hspbz`,
	"flex_btn_container": `routes_flex_btn_container__Tv-7e`,
	"otpBtn": `routes_otpBtn__mjcPS`,
	"preHeader": `routes_preHeader__mPDj-`,
	"iconPara": `routes_iconPara__0BkZC`,
	"lowerContainer": `routes_lowerContainer__HtG7Z`,
	"selfieBox": `routes_selfieBox__BWbxs`,
	"modalOpened": `routes_modalOpened__dahRz`,
	"btnDiv": `routes_btnDiv__6bEwX`
};
export default ___CSS_LOADER_EXPORT___;
